import AdsStatusModal from "@/components/common/modals/ads-status-modal";
import LiveModal from "@/components/common/modals/live";
import PhotoVideoModal from "@/components/common/modals/photo-video";
import UploadPostModal from "@/components/common/modals/upload-Post";
import DeleteModal from "@/components/common/modals/delete-modal";

/* ------- Modal variants -------- */
const MODAL_VARIANTS = {
  uploadPost: UploadPostModal,
  photoVideo: PhotoVideoModal,
  liveModal: LiveModal,
  adsStatusModal: AdsStatusModal,
  deleteModal: DeleteModal,
};

const MainModal = ({ variant = "uploadPost", show, handleClose, ...rest }) => {
  const VaraintComponent = MODAL_VARIANTS[variant];

  if (!VaraintComponent) {
    if (process.env.NODE_ENV === "development") {
      console.warn(
        `[PostModal] Unknown variant "${variant}". ` +
          `Valid options: ${Object.keys(MODAL_VARIANTS).join(", ")}`,
      );
    }
    return null;
  }

  return <VaraintComponent show={show} handleClose={handleClose} {...rest} />;
};

export default MainModal;